import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import logo from '../../../assets/images/logo.webp';
export const WelcomePage = () => {
    const { base_url, setUser } = useAppContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user_id: user_id_param } = useParams();
    const user_id = parseInt(user_id_param);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        job_title: '',
        password: '',
        confirm_password: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    // Get token from query params
    const token = searchParams.get('token');

    // Redirect if no token provided or invalid user_id
    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
        if (isNaN(user_id) || user_id <= 0) {
            window.showAlert(400, 'Invalid user ID');
            navigate('/login');
        }
    }, [token, user_id, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Validate required fields
        if (!formData.first_name || !formData.last_name || !formData.password) {
            window.showAlert(400, 'Please fill in all required fields');
            setIsLoading(false);
            return;
        }

        // Validate password confirmation
        if (formData.password !== formData.confirm_password) {
            window.showAlert(400, 'Passwords do not match');
            setIsLoading(false);
            return;
        }

        // Validate password length
        if (formData.password.length < 8) {
            window.showAlert(400, 'Password must be at least 8 characters long');
            setIsLoading(false);
            return;
        }

        try {
            console.log('Setting up user profile with data:', formData);
            const response = await updateData(token, `${base_url}/apis/admin/profile`, {
                first_name: formData.first_name,
                last_name: formData.last_name,
                job_title: formData.job_title,
                password: formData.password,
                confirm_password: formData.confirm_password
            });

            if (response && response.user) {
                setUser(response.user);
                window.showAlert(200, 'Profile setup successful!');
                console.log('Profile setup successful!');
                // Redirect to dashboard after successful setup
                navigate('/');
            } else {
                window.showAlert(response?.status || 400, response?.msg || 'Failed to setup profile. Please try again.');
            }
        } catch (err) {
            window.showAlert(err?.status || 400, err?.msg || 'Failed to setup profile. Please try again.');
            console.error('Profile setup error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    // Don't render if no token
    if (!token) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content settings-modal">
                <div className="modal-header">
                    <img src={logo} alt="MTS Logo" className="auth-page__logo--sm" />
                    <h2>Welcome to the MTS Projects Portal!</h2>
                    <p className="welcome-subtitle">
                        Please complete your profile setup to get started.
                    </p>
                </div>
                
                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-group">
                        <label htmlFor="first_name" className="form-label">
                            First Name *
                        </label>
                        <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            className="form-input"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter your first name"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="last_name" className="form-label">
                            Last Name *
                        </label>
                        <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            className="form-input"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter your last name"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="job_title" className="form-label">
                            Job Title
                        </label>
                        <input
                            type="text"
                            id="job_title"
                            name="job_title"
                            className="form-input"
                            value={formData.job_title}
                            onChange={handleInputChange}
                            placeholder="Enter your job title"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password" className="form-label">
                            Password *
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="form-input"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                            placeholder="Create a password"
                            minLength="8"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirm_password" className="form-label">
                            Confirm Password *
                        </label>
                        <input
                            type="password"
                            id="confirm_password"
                            name="confirm_password"
                            className="form-input"
                            value={formData.confirm_password}
                            onChange={handleInputChange}
                            required
                            placeholder="Confirm your password"
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Setting up...' : 'Complete Setup'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
